import { reactive } from 'vue';
import ja from './ja.json';
import en from './en.json';

const messages = {
  ja,
  en
};

function detectInitialLocale() {
  const saved = localStorage.getItem('user_locale');
  if (saved && (saved === 'ja' || saved === 'en')) {
    return saved;
  }
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (browserLang.startsWith('ja')) {
    return 'ja';
  }
  return 'en';
}

export const i18nState = reactive({
  locale: detectInitialLocale()
});

export function setLocale(lang) {
  if (lang === 'ja' || lang === 'en') {
    i18nState.locale = lang;
    localStorage.setItem('user_locale', lang);
  }
}

export function translate(key) {
  const currentMessages = messages[i18nState.locale] || messages.ja;
  const keys = key.split('.');
  let result = currentMessages;
  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k];
    } else {
      return key;
    }
  }
  return typeof result === 'string' ? result : key;
}

export default {
  install(app) {
    app.config.globalProperties.$t = (key) => translate(key);
    app.config.globalProperties.$i18n = i18nState;
    app.config.globalProperties.$setLocale = setLocale;
    app.provide('i18n', i18nState);
  }
};
